import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const AZinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params

  const options3 = [
    { key: 1, value: '0.5%' },
    { key: 2, value: '1.0%' },
    { key: 3, value: '1.5%' },
    { key: 4, value: '2.0%' },
    { key: 5, value: '2.5%' },
    { key: 6, value: '3.0%' },
    { key: 7, value: '3.5%' },

  ]


  const options1 = [
    { key: 1, value: 'Withhold from gross taxable wages at the percentage checked ' },
    { key: 2, value: 'I elect an Arizona withholding percentage of zero,and i certify that i except to have no Arizona tax liability for the current taxable year' },
  ]

  const intialValues = {
    typeOfWithhold: "",
    additionalAmount: "",
    withholdPercentage: ""
  }
  const alschema = yup.object({
    typeOfWithhold: yup.string().required("Type of withholding is a required field"),
    // additionalAmount: yup.string().when("typeOfWithhold", (typeOfWithhold: any, schema) => {
    //   if (typeOfWithhold == 1) {
    //     return schema.required("Additional amount is a required field")
    //   }
    //   return schema.nullable()
    // }),
    withholdPercentage: yup.string().when("typeOfWithhold", (typeOfWithhold: any, schema) => {
      if (typeOfWithhold == 1) {
        return schema.required("Withhold percentage is a required field")
      }
      return schema.nullable()
    }),

  })
  const { loading, postazonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AZ Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            const withholdpercentage = values?.withholdPercentage
            const data = {
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              completeOnline: mode == "online" ? true : false,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              // extraAmount: values?.additionalAmount ? values?.additionalAmount : null,
              typeOfWithhold: values?.typeOfWithhold,
              withholdPercentage: values?.withholdPercentage || null
            }

            const response = await postazonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('AZinformationonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  withholdpercentage
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            }
            else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Type Of Withholding *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Type Of Withholding"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.typeOfWithhold
                      )}
                      onSelect={(option: any) => {
                        if (option == 2) {
                          props.setFieldValue("additionalAmount", "")
                          props.setFieldValue("withholdPercentage", "")
                        }
                        props.setFieldValue('typeOfWithhold', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.typeOfWithhold &&
                      props.errors.typeOfWithhold && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.typeOfWithhold}
                        </Text>
                      )}
                  </View>
                </View>

                {Number(props.values.typeOfWithhold) == 1 && props.values.typeOfWithhold != null ? <>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Select the percentage to withhold from gross taxable wages.*'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title={"Select the percentage to withhold from gross taxable wages."}
                        options={options3}
                        selectedOption={mapSelectValue(
                          options3,
                          props.values.withholdPercentage
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('withholdPercentage', option)
                        }}
                        textColor="primary"
                      />
                      {props.touched.withholdPercentage &&
                        props.errors.withholdPercentage && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.withholdPercentage as string}
                          </Text>
                        )}
                    </View>
                  </View>

                  {/* <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '30%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Enter an extra amount to be withheld from each paycheck  *'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalAmount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalAmount')(text)
                          }
                        }}
                      />
                      {props.touched.additionalAmount && props.errors.additionalAmount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalAmount}
                        </Text>
                      )}
                    </View>
                  </View> */}
                </> : <></>
                }


                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default AZinformationForm
